import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '漫画分类',
    links: [
      { label: '热门推荐', href: '/category/rexia-recommend' },
      { label: '恋爱漫画', href: '/category/lianai-romance' },
      { label: '奇幻冒险', href: '/category/qihuan-fantasy' },
      { label: '动作热血', href: '/category/dongzuo-action' },
      { label: '悬疑惊悚', href: '/category/xuanyi-thriller' },
      { label: '搞笑日常', href: '/category/gaoxiao-comedy' },
      { label: 'BL漫画', href: '/category/bl-comics' },
      { label: 'GL漫画', href: '/category/gl-comics' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', href: '/about' },
      { label: '联系我们', href: '/about#contact' },
      { label: '常见问题', href: '/#faq' },
      { label: '用户协议', href: '/about' },
      { label: '隐私政策', href: '/about' },
    ],
  },
  {
    title: '帮助中心',
    links: [
      { label: '阅读指南', href: '/about' },
      { label: '更新日志', href: '/about' },
      { label: '意见反馈', href: '/about#contact' },
      { label: '商务合作', href: '/about#contact' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link
              to="/"
              className="flex items-center gap-2 font-heading text-xl font-bold text-background-50 hover:text-background-100 transition-colors duration-200 whitespace-nowrap"
            >
              <i className="ri-book-open-line text-2xl"></i>
              <span>韩漫大全</span>
            </Link>
            <p className="mt-4 text-sm text-background-100/80 leading-relaxed">
              韩漫大全 - 最全面的韩国漫画在线阅读平台。我们致力于为韩漫爱好者提供无删减、高质量的免费漫画阅读体验，支持下拉式阅读，让您的阅读更加流畅舒适。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/15 hover:bg-background-50/25 transition-colors duration-200" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/15 hover:bg-background-50/25 transition-colors duration-200" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/15 hover:bg-background-50/25 transition-colors duration-200" aria-label="QQ" rel="nofollow">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-100/70 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-100/60">
            &copy; {new Date().getFullYear()} 韩漫大全 - 韩国漫画无删减下拉式阅读平台。本站所有漫画内容仅供学习交流使用。
          </p>
          <div className="flex items-center gap-4 text-xs text-background-100/60">
            <a href="/about" className="hover:text-background-50 transition-colors duration-200 whitespace-nowrap">用户协议</a>
            <a href="/about" className="hover:text-background-50 transition-colors duration-200 whitespace-nowrap">隐私政策</a>
            <a href="/about#contact" className="hover:text-background-50 transition-colors duration-200 whitespace-nowrap">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}